import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Table } from 'react-bootstrap';
import axios from 'axios';

export default function PublishingHistory({ siteId }) {
  const [site, setSite] = useState(null);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    const [siteResponse, deployments] = await Promise.all([
      axios.get(`/api/publishing/sites/${siteId}/`), axios.get(`/api/publishing/sites/${siteId}/deployments/`)
    ]);
    setSite(siteResponse.data); setHistory(deployments.data);
  }, [siteId]);
  const report = err => setError(typeof err.response?.data === 'string' ? err.response.data : 'Could not load publishing information');
  useEffect(() => { load().catch(report); }, [load]);
  const change = async action => {
    setBusy(true); setError(null);
    try { await action(); await load(); } catch (err) { report(err); } finally { setBusy(false); }
  };
  return <div className="py-3">
    {error && <Alert variant="danger">{error}</Alert>}
    {site && <>
      <p>Owner: <strong>{site.customer_id}</strong> · Status: <strong>{site.status}</strong></p>
      <p>Archiving pauses customer publishing. The public website stays online. Restore it here to allow publishing again.</p>
      <Button className="me-2" disabled={busy} variant="outline-secondary" onClick={() => change(() => axios.post(
        `/api/publishing/sites/${siteId}/archive/`, { archived: site.status !== 'archived' }))}>
        {site.status === 'archived' ? 'Restore publishing' : 'Archive publishing'}
      </Button>
      <Button disabled={busy || site.status !== 'active' || !history.some(item => item.state === 'succeeded')} variant="outline-danger" onClick={() => {
        if (window.confirm('Replace the live site with its retained previous release? This changes the public website.')) {
          const operation_key = crypto.randomUUID().replaceAll('-', '');
          change(() => axios.post(`/api/publishing/sites/${siteId}/rollback/`, { expected_version: site.version, operation_key }));
        }
      }}>Roll back previous release</Button>
    </>}
    <h3 className="h5 mt-4">Deployment history</h3>
    <Table responsive><thead><tr><th>When</th><th>Actor</th><th>Status</th><th>Details</th></tr></thead>
      <tbody>{history.map(item => <tr key={item.id}><td>{new Date(item.created_at * 1000).toLocaleString()}</td>
        <td>{item.actor_id}</td><td>{item.state}</td><td>{item.error || item.id}</td></tr>)}</tbody>
    </Table>
    {!history.length && <p>No customer deployments recorded.</p>}
  </div>;
}
